import { PrinterPosPlusIcon } from './PrinterPosPlusIcon';

/**
 * author: Colton Wiscombe
 * id 45895F8B-BD11-410E-859F-E48AC25AA0EF
 * name printer-pos-plus
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-plus.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSalePlusIcon = PrinterPosPlusIcon;
export default PrinterPointOfSalePlusIcon